import { Badge } from '@/components/ui/badge';
import type { SyncStatus } from '@/types/api';

interface SyncStatusBadgeProps {
  status: SyncStatus;
}

export function SyncStatusBadge({ status }: SyncStatusBadgeProps): JSX.Element {
  switch (status) {
    case 'not_started':
      return (
        <Badge variant="outline" data-testid="sync-status-not-started">
          Not Started
        </Badge>
      );
    case 'idle':
      return (
        <Badge variant="success" data-testid="sync-status-idle">
          Idle
        </Badge>
      );
    case 'syncing':
      return (
        <Badge variant="default" data-testid="sync-status-syncing">
          <span className="mr-1.5 h-2 w-2 animate-pulse rounded-full bg-current" />
          Syncing
        </Badge>
      );
    case 'paused':
      return (
        <Badge variant="warning" data-testid="sync-status-paused">
          Paused
        </Badge>
      );
    default:
      return (
        <Badge variant="secondary" data-testid="sync-status-unknown">
          Unknown
        </Badge>
      );
  }
}
